module.exports = __webpack_public_path__ + "img/act_pro_img21s_03.262823eb.png";